/* import __COLOCATED_TEMPLATE__ from './full.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();